import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { DocumentService } from '../../services/document.service';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../services/sharedService';

const HELP_TEXT_KEY = 'PORTAL_HELP_TEXT';
const CONTACT_INFO_KEY = 'PORTAL_CONTACT_INFO';
const DOC_ENTITY = 'portal-help';
const DOC_ENTITY_ID = 'global';

export interface ContactInfoRow {
    label: string;
    value: string;
    type: 'email' | 'phone' | 'text';
}

@Component({
    selector: 'app-portal-content',
    templateUrl: './portal-content.component.html',
    standalone: false,
})
export class PortalContentComponent implements OnInit, AfterViewInit {
    helpText = '';
    contactInfo: ContactInfoRow[] = [];
    documents: any[] = [];
    private adminSettings: any = {};

    constructor(
        private settings: AdminService,
        private documentService: DocumentService,
        private alertService: ToastrService,
        private sharedService: SharedService,
    ) {}

    ngOnInit(): void {
        this.load();
        this.loadDocuments();
    }

    ngAfterViewInit(): void {
        this.sharedService.loadMenuItems('admin');
    }

    load(): void {
        this.settings.getAdminSettings().subscribe((settings) => {
            this.adminSettings = settings && settings.length > 0 ? settings[0] : {};
            this.helpText = this.adminSettings[HELP_TEXT_KEY] || '';
            this.contactInfo = this.adminSettings[CONTACT_INFO_KEY] || [];
        });
    }

    loadDocuments(): void {
        this.documentService.list$(DOC_ENTITY, DOC_ENTITY_ID).subscribe(
            (docs: any) => { this.documents = docs || []; },
            () => { this.documents = []; this.alertService.error('Failed to load attachments'); },
        );
    }

    onFilesSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (!input.files || !input.files.length) return;
        const files = Array.from(input.files);
        input.value = '';
        files.forEach((file) => {
            this.documentService.add$(DOC_ENTITY, DOC_ENTITY_ID, file).subscribe(
                () => { this.alertService.success(`${file.name} uploaded successfully`); this.loadDocuments(); },
                () => { this.alertService.error(`Failed to upload ${file.name}`); },
            );
        });
    }

    deleteDocument(doc: any): void {
        if (!confirm(`Are you sure you want to delete "${doc.originalname}"?`)) return;
        this.documentService.delete$(doc.id).subscribe(
            () => { this.alertService.success(`${doc.originalname} deleted`); this.loadDocuments(); },
            () => { this.alertService.error(`Failed to delete ${doc.originalname}`); },
        );
    }

    addContactRow(): void {
        this.contactInfo.push({ label: '', value: '', type: 'email' });
    }

    removeContactRow(index: number): void {
        this.contactInfo.splice(index, 1);
    }

    save(): void {
        const payload: any = { id: this.adminSettings.id };
        payload[HELP_TEXT_KEY] = this.helpText;
        payload[CONTACT_INFO_KEY] = this.contactInfo;
        this.settings.saveAdminSettings(payload).subscribe((data) => {
            this.adminSettings = data;
            this.alertService.success('Portal content saved successfully');
        });
    }
}
